import { cn } from "@/utils/theme";
import { AttachmentInput } from "../../notification/components/attachment-input";
import type { NodeVariable } from "../../types";
import { useResolution } from "../context";
import { Icon } from "@elaniintc/goes-design-system";

interface ResolutionFilesProps {
  variables: NodeVariable[];
  disabled?: boolean;
}
export const ResolutionFiles = ({
  variables,
  disabled,
}: ResolutionFilesProps) => {
  const { attachments, setAttachments } = useResolution();

  return (
    <div className="flex flex-col gap-1">
      <label
        className={cn(
          "font-semibold text-body-loud text-sm leading-2xl",
          disabled && "text-on-disabled!",
        )}
      >
        Documentos adjuntos
      </label>

      {disabled ? (
        // placeholder disabled view
        <div className="flex justify-between items-center text-on-disabled px-3 py-2 bg-neutral-object-accent-silent border border-neutral rounded-lg">
          Elige archivos...
          <Icon type="far" name="chevron-down" />
        </div>
      ) : (
        <AttachmentInput
          variables={variables}
          selectedAttachments={attachments}
          onChange={(newAttachments) => setAttachments(newAttachments)}
        />
      )}
    </div>
  );
};
